import React, { useEffect, useState, useRef } from 'react';
import css from './notification.module.css'; // Correct import for CSS Module
import { useTranslation } from 'react-i18next';
import { useParams, useHistory } from 'react-router-dom';
import { useService } from '../../services/services';
import Spinner from '../common/spinner';
import moment from 'moment';
import { route } from '../../services/utils';
import { WAREHOUSE_DEAL_EDIT } from '../../router/routes';

const Notification = ({ isOpen, onClose }) => {
  const [notifications, setNotifications] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isRejected, setIsRejected] = useState<boolean>(false);
  const [refetch, setRefetch] = useState<number>(0);

  const { farmId } = useParams<{ farmId: string }>();
  const { authService } = useService();
  const history = useHistory();
  const wrapperRef = useRef(null);

  const { t } = useTranslation();

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onClose();
        setIsRejected(false);
        setIsLoading(true);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef, onClose]);

  useEffect(() => {
    if (isOpen) {
      authService.notifications(farmId).subscribe((v) => {
        setNotifications(v);
        setIsLoading(false);
      });
    }
  }, [authService, farmId, isOpen, refetch]);

  const reject = (notificationId: string, notificationType: string) => {
    setIsLoading(true);
    authService
      .notificationReject(farmId, notificationId, notificationType)
      .subscribe((v) => {
        setRefetch((old) => old + 1);
        setIsRejected(true);
      });
  };

  const add = (notificationId: string, notificationType: string) => {
    authService
      .notificationAccept(farmId, notificationId, notificationType)
      .subscribe((v) => {
        history.push(
          route(WAREHOUSE_DEAL_EDIT, {
            farmId,
            id: v.deal_id,
            dealType: v.deal_type,
          })
        );
      });
  };

  if (!isOpen) return null;

  return (
    <>
      <div className={`${css['overlay']}`} />
      <div
        className={`${css['menu-wrapper']} ${isOpen && css['opened']}`}
        ref={wrapperRef}
      >
        <div className={css['decorator-wrapper']}>
          <div className={css['decorator']} />
        </div>
        <div className={css['menu']}>
          {isRejected && (
            <div className={css['reject-information']}>
              {t('components.notification.reject_notification')}
            </div>
          )}
          <div className={css['spinner-wrapper']}>
            <Spinner visible={isLoading} size="lg" />
          </div>
          {!isLoading && (
            <div className={css['notification-list']}>
              {notifications.map((notification, index) => (
                <div key={index}>
                  <p className={css['date']}>
                    {moment(notification.deal_date).format('DD.MM.YYYY')}
                  </p>
                  <div className={css['main-content']}>
                    <h4 className={css['notification-title']}>
                      {notification.partner_name}
                    </h4>
                    <div className={css['notification-buttons']}>
                      <button
                        className={css['reject-button']}
                        onClick={() =>
                          reject(
                            notification.notification_id,
                            notification.type
                          )
                        }
                      >
                        {t('components.notification.reject')}
                      </button>

                      <button
                        className={css['add-button']}
                        onClick={() =>
                          add(notification.notification_id, notification.type)
                        }
                      >
                        {t('components.notification.add')}
                      </button>
                    </div>
                  </div>
                  <div>
                    {notification.deal_products.map((product, index) => (
                      <h4 key={index}>
                        {`${product.product_name} ${product.amount}${
                          product.unit
                        } - ${
                          product.sum_with_vat !== '0.00'
                            ? product.sum_with_vat
                            : product.sum
                        } EUR`}
                      </h4>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Notification;
